import {Component, Input, OnInit, Output, EventEmitter, OnDestroy, ChangeDetectorRef, ElementRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {IAlternateSecurities, IAlternativeSecurity, ICustomCategory} from "@irb/irb-editors/irb-editors.model";
import {UtilityService} from "@irb-common/services/utility.service";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {AppService} from "@irb/app.service";
import {Subscription} from "rxjs";
import {IEvent} from "@irb-common/events";
import {AbstractControl, FormControl, Validators} from "@angular/forms";
import {TooltipService} from '@irb-common/components/tooltip/tooltip.service';
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
    selector: 'irb-trading-minimums',
    templateUrl: './trading-minimums.component.html',
    styleUrls: ['./trading-minimums.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class TradingMinimumsComponent implements OnInit, OnDestroy {
    @ViewChild("alternativeSecuritiesDropdown") alternativeSecuritiesDropdown: any;
    _tradingMinimumData: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] };
    minDollarValue = 0;
    maxDollarValue = 999999999;
    maxDollarPercent = 100;
    minDollarPercent = 0;
    private places = 2;
    tradeMinimumsMinBuyDollarInputField: ElementRef;
    tradeMinimumsMinSellDollarInputField: ElementRef;
    tradeMinimumsMinBuyPercentInputField: ElementRef;
    tradeMinimumsMinSellPercentInputField: ElementRef;

    // todo remove these 4 form controls once input behaviors are set with common component.
    tradeMinimumsMinBuyDollarInputControl: FormControl = new FormControl();
    tradeMinimumsMinSellDollarInputControl: FormControl = new FormControl();
    tradeMinimumsMinBuyPercentInputControl: FormControl = new FormControl();
    tradeMinimumsMinSellPercentInputControl: FormControl = new FormControl();

    minBuyDollarTooltipMessage = "";
    minSellDollarTooltipMessage = "";
    minBuyPercentTooltipMessage = "";
    minSellPercentTooltipMessage = "";

    private eventSubscription: Subscription;
    minBuyDollarInitial?: any;
    minBuyDollarPlaceHolder: any;
    minSellDollarInitial?: any;
    minSellDollarPlaceHolder: any;
    minBuyPercentInitial?: any;
    minBuyPercentPlaceHolder: any;
    minSellPercentInitial?: any;
    minSellPercentPlaceHolder: any;
    minBuyDollar?: any;
    minBuyDollarPrev: any;
    minSellDollar?: any;
    minSellDollarPrev: any;
    minBuyPercent?: any;
    minBuyPercentPrev: any;
    minSellPercent?: any;
    minSellPercentPrev: any;
    alternateSecuritySelectedInitial: any;
    alternateSecuritySelected: any;
    selectedAltSecurity: IDropdownItem;
    alternativeSecurities: Array<IDropdownItem> = [];
    alternateSecurityPlaceHolder = "";
    overrideValues: boolean = false;
    securityType: string;
    private _isDataLoaded: boolean = false;
    addNewSecurityItem: any = {
        button: 'Add new security',
        type: 'security',
        fromComp: 'TradingMinimumsComponent'
    };
    @Output()
    alternateSecurityChanged: EventEmitter<IDropdownItem> = new EventEmitter<IDropdownItem>();
    @Output()
    dollarPercentChanged: EventEmitter<{ key: string, data: any }> = new EventEmitter<{ key: string, data: any }>();

    @Input()
    set tradingMinimumData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._isDataLoaded = false;
        this._tradingMinimumData = value;
        this.loadData();
    }

    @Input() editModel: boolean = false;

    constructor(private irbEditorsService: IrbEditorsService, private utilService: UtilityService,
                private as: AppService, private cdr: ChangeDetectorRef, private tts: TooltipService
    ) {
    }

    ngOnInit(): void {
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });

        this.irbEditorsService.getMinSubAlternatives().subscribe((securityAlternatives: IAlternateSecurities) => {
                securityAlternatives.items.forEach((item: any) => {
                    this.alternativeSecurities.push({
                        name: item.securitySymbol,
                        value: item.securityId
                    } as IDropdownItem);
                });

                this.utilService.sortByKey(this.alternativeSecurities, "name", "asc");

                this.alternativeSecurities.unshift({
                    name: "None",
                    value: 0
                } as IDropdownItem);

                this.setAlternateSecurity();
            });

        this.loadData();
    }

    private processEvent(event: IEvent) {

        switch (event.type) {
            case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
                if (event.data && event.data.editSecurity === true) {
                    this.addNewlyCreatedSecurity(event);
                }if (event.data.type === 'security' && event.data.fromComp === 'TradingMinimumsComponent') {
                    this.resetSecuritySearch(event.data)
                }
                break;   
        }
    }

    private loadData() {
        if (this._tradingMinimumData) {
            if (this._tradingMinimumData.multipleSecurity) {
                this.loadMultipleSecurity();
            } else {
                this.loadSingleSecurity();
            }
            this.setAlternateSecurity();
            this._isDataLoaded = true;
            this.initializeFormStructure();
        }
    }

    private loadSingleSecurity() {
        // this.minBuyDollar = this._tradingMinimumData.securityData[0].buy
        this.minBuyDollarPlaceHolder = "";
        this.minBuyPercentPlaceHolder ="";
        this.minSellDollarPlaceHolder = "";
        this.minSellPercentPlaceHolder ="";

        this.alternateSecuritySelectedInitial = "";
        if (this._tradingMinimumData && this._tradingMinimumData.securityData) {
            this.minBuyDollarInitial = this._tradingMinimumData.securityData[0].buyMinimum ? this._tradingMinimumData.securityData[0].buyMinimum : 0;
            this.minBuyDollar = this._tradingMinimumData.securityData[0].buyMinimum ? this._tradingMinimumData.securityData[0].buyMinimum : 0;
            this.minBuyPercentInitial = this._tradingMinimumData.securityData[0].buyMinimumPercent ? this._tradingMinimumData.securityData[0].buyMinimumPercent : 0;
            this.minBuyPercent = this._tradingMinimumData.securityData[0].buyMinimumPercent ? this._tradingMinimumData.securityData[0].buyMinimumPercent : 0;
            this.minSellDollarInitial = this._tradingMinimumData.securityData[0].sellMinimum ? this._tradingMinimumData.securityData[0].sellMinimum : 0;
            this.minSellDollar = this._tradingMinimumData.securityData[0].sellMinimum ? this._tradingMinimumData.securityData[0].sellMinimum : 0;
            this.minSellPercentInitial = this._tradingMinimumData.securityData[0].sellMinimumPercent ? this._tradingMinimumData.securityData[0].sellMinimumPercent : 0;
            this.minSellPercent = this._tradingMinimumData.securityData[0].sellMinimumPercent ? this._tradingMinimumData.securityData[0].sellMinimumPercent : 0;
            this.securityType = this._tradingMinimumData.securityData[0].securityType;
            this.overrideValues = this._tradingMinimumData.securityData[0].isFundImposedMinOverridden;

            this.minBuyDollarPrev = this.minBuyDollar;
            this.minSellDollarPrev = this.minSellDollar;
            this.minBuyPercentPrev = this.minBuyPercent;
            this.minSellPercentPrev = this.minSellPercent;
            this.setAlternateSecurity();
        }
    }

    private loadMultipleSecurity() {
        this.alternateSecuritySelectedInitial = "";
        if (this._tradingMinimumData && this._tradingMinimumData.securityData
            && this._tradingMinimumData.securityData.length > 0) {
            this.minBuyDollarInitial = this.getInitialValue("buyMinimum", this._tradingMinimumData.securityData);
            this.minBuyDollar = this.minBuyDollarInitial === 'Various' ? null : this.minBuyDollarInitial;
            this.minBuyDollarPlaceHolder = this.minBuyDollarInitial === 'Various' ? this.minBuyDollarInitial : "";

            this.minBuyPercentInitial = this.getInitialValue("buyMinimumPercent", this._tradingMinimumData.securityData);
            this.minBuyPercent = this.minBuyPercentInitial === 'Various' ? null : this.minBuyPercentInitial;
            this.minBuyPercentPlaceHolder = this.minBuyPercentInitial === 'Various' ? this.minBuyPercentInitial : "";

            this.minSellDollarInitial = this.getInitialValue("sellMinimum", this._tradingMinimumData.securityData);
            this.minSellDollar = this.minSellDollarInitial === 'Various' ? null : this.minSellDollarInitial;
            this.minSellDollarPlaceHolder = this.minSellDollarInitial === 'Various' ? this.minSellDollarInitial : "";

            this.minSellPercentInitial = this.getInitialValue("sellMinimumPercent", this._tradingMinimumData.securityData);
            this.minSellPercent = this.minSellPercentInitial === 'Various' ? null : this.minSellPercentInitial;
            this.minSellPercentPlaceHolder = this.minSellPercentInitial === 'Various' ? this.minSellPercentInitial : "";

            this.minBuyDollarPrev = this.minBuyDollar;
            this.minSellDollarPrev = this.minSellDollar;
            this.minBuyPercentPrev = this.minBuyPercent;
            this.minSellPercentPrev = this.minSellPercent;

            this.setAlternateSecurity();
        } else {
            this.loadSingleSecurity();
        }
    }

    private getInitialValue(name: string, items: any[]) {
        let inputVal = items[0][name];

        for (let i = 0; i < items.length; i++) {
            const thisVal = items[i][name];
            if (inputVal !== thisVal) {
                inputVal = "Various";
            }
        }

        return inputVal;
    }

    private setAlternateSecurity() {
        if (this._tradingMinimumData && this._tradingMinimumData.multipleSecurity) {
            this.alternateSecuritySelectedInitial = this.alternateSecuritySelected
                = this.getInitialValue("tradeMinimumAlternative", this._tradingMinimumData.securityData);
        } else {
            this.alternateSecuritySelectedInitial = this._tradingMinimumData.securityData[0].tradeMinimumAlternative;
            this.alternateSecuritySelected = this._tradingMinimumData.securityData[0].tradeMinimumAlternative;
        }

        if (this.alternateSecuritySelectedInitial === "Various") {
            this.alternateSecurityPlaceHolder = "Various";
        }

        if (this.alternativeSecurities && this.alternativeSecurities.length > 0) {
            const altSelected = this.alternativeSecurities.find(x => x.value === this.alternateSecuritySelectedInitial);
            this.selectedAltSecurity = altSelected;
            this.alternativeSecuritiesDropdown.setValue(this.selectedAltSecurity);
        }
    }

    resetSecuritySearch(event: any) {
        const dataParam: any = event;
        if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
            this.alternativeSecurities = this.alternativeSecurities.concat(dataParam.newItems);

            if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
                this.alternativeSecuritiesDropdown.setValue(dataParam.newItemsForDD);
                this.selectedAltSecurity = dataParam.newItemsForDD[0];
                this.onAlternativeSecurityChanged(dataParam.newItemsForDD[0]);
            }
            this.irbEditorsService.getMinSubAlternatives().subscribe((securityAlternatives: IAlternateSecurities) => {
                this.alternativeSecurities = [];
                securityAlternatives.items.forEach((item: any) => {
                    this.alternativeSecurities.push({
                        name: item.securitySymbol,
                        value: item.securityId
                    } as IDropdownItem);
                });
                this.utilService.sortByKey(this.alternativeSecurities, "name", "asc");
            });
        }
    }

    onAlternativeSecurityChanged(event: IDropdownItem) {
        this.alternateSecuritySelected = event.value;
        this.alternateSecurityChanged.emit(event);
    }

    onAlternateSecurityAdded(selectedSecurity: IDropdownItem) {
        this.alternateSecuritySelected = selectedSecurity.value;
        this.alternateSecurityChanged.emit(selectedSecurity);
    }

    onMinBuyDollarChanged(event: any) {
        if (!isNaN(event) && this._isDataLoaded && this.minBuyDollar !== this.minBuyDollarPrev) {
            this.dollarPercentChanged.emit({key: 'buyMinimum', data: Number(this.minBuyDollar)});
        }
    }

    onMinSellDollarChanged(event: any) {
        if (!isNaN(event) && this._isDataLoaded && this.minSellDollar !== this.minSellDollarPrev) {
            this.dollarPercentChanged.emit({key: 'sellMinimum', data: Number(this.minSellDollar)});
        }
    }

    onMinBuyPercentChanged(event: any) {
        if (!isNaN(event) && this._isDataLoaded && this.minBuyPercent !== this.minBuyPercentPrev) {
            this.dollarPercentChanged.emit({key: 'buyMinimumPercent', data: Number(this.minBuyPercent)});
        }
    }

    onMinSellPercentChanged(event: any) {
        if (!isNaN(event) && this._isDataLoaded && this.minSellPercent !== this.minSellPercentPrev) {
            this.dollarPercentChanged.emit({key: 'sellMinimumPercent', data: Number(this.minSellPercent)});
        }
    }

    onOverrideValuesChanged(event: any) {
        let eventData = event;
        this.dollarPercentChanged.emit({key: 'isFundImposedMinOverridden', data: this.overrideValues});
    }

    formatSecurityType(securityType: any) {

        switch (securityType) {

            case "EQUITY":
                return "Equity";
            case "EQ":
                return "Equity";
            case "MUTUAL_FUND":
                return "Mutual Fund";
            case "MF":
                return "Mutual Fund";
            case "CASH":
                return "Cash";
            case "GROUP":
                return "Group";
            case "BOND":
                return "Bond";
            case "OTHER":
                return "Other";
            case "EXTERNAL":
                return "External";
            case "CustCat":
                return "Category";
            case "OPTION":
                return "Option";
            default:
                return securityType;
        }
    }

    onCreateNewSecurity() {
        const dataParam: any = {
            editSecurity: true,
            editMinAlt: true
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    addNewlyCreatedSecurity(event: IEvent) {
        const newData = event.data;
        const alternativeSecurities: Array<IDropdownItem> = [];

        if (newData.securities && newData.securities.responseData && newData.securities.responseData.length !== 0) {
            let newSecurityItem: any;
            newData.securities.responseData.forEach((item: any) => {
                newSecurityItem = this.buildAlternativeSecurityItem(item);
                alternativeSecurities.push(newSecurityItem);
            });

            if (alternativeSecurities && alternativeSecurities.length > 0) {
                let newConsolidatedAlternatives: Array<IDropdownItem> = [];

                if (this.alternativeSecurities?.length > 0) {
                    newConsolidatedAlternatives.push(...this.alternativeSecurities);
                }

                newConsolidatedAlternatives.push(...alternativeSecurities);
                const noneItemIndex = newConsolidatedAlternatives.findIndex(x => x.value === 0);
                
                if (noneItemIndex >= 0) {
                    newConsolidatedAlternatives.splice(noneItemIndex, 1);
                }

                newConsolidatedAlternatives = this.utilService.sortByKey(newConsolidatedAlternatives, "name", "asc");

                newConsolidatedAlternatives.unshift({
                    name: "None",
                    value: 0
                } as IDropdownItem);

                this.alternativeSecurities = newConsolidatedAlternatives;
                
                if (event.data && event.data.editSecurity && event.data.editMinAlt === true) {
                    if (alternativeSecurities && alternativeSecurities.length === 1) {
                        const selectedSecurity = this.alternativeSecurities.find(x => x.value === alternativeSecurities[0].value);
                        this.selectedAltSecurity = selectedSecurity;
                        this.onAlternateSecurityAdded(selectedSecurity);
                    } else {
                        const selectedSecurity = this.alternativeSecurities.find(x => x.value === this.selectedAltSecurity.value);
                        this.selectedAltSecurity = selectedSecurity;
                    }
                } else {
                    if (this.selectedAltSecurity) {
                        const selectedSecurity = this.alternativeSecurities.find(x => x.value === this.selectedAltSecurity.value);
                        this.selectedAltSecurity = selectedSecurity;
                    }
                }

                this.cdr.detectChanges();
            }


        }
    }

    private buildAlternativeSecurityItem(response: any) {
        const newAlternateSecurity: IDropdownItem = {
            value: response.securityId,
            name: response.securitySymbol,
        };

        return newAlternateSecurity;
    }

    ngOnDestroy(): void {
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
        }
    }

    onMinBuyDollarInput() {
        if (this.tradeMinimumsMinBuyDollarInputControl && !this.tradeMinimumsMinBuyDollarInputControl.valid
            && this.tradeMinimumsMinBuyDollarInputControl.errors) {
            if (this.tradeMinimumsMinBuyDollarInputControl.hasError('requiredIfTouched')) {
                this.minBuyDollarTooltipMessage = "Min Buy $ is required";
            } else if (this.tradeMinimumsMinBuyDollarInputControl.hasError('NotANumber')) {
                this.minBuyDollarTooltipMessage = "Please enter only whole numbers.";
            } else if (this.tradeMinimumsMinBuyDollarInputControl.hasError('min') ||
                this.tradeMinimumsMinBuyDollarInputControl.hasError('max')) {
                this.minBuyDollarTooltipMessage = "Please enter only numbers between 0 and 999999999.";
            } else if (this.tradeMinimumsMinBuyDollarInputControl.hasError('pattern')) {
                this.minBuyDollarTooltipMessage = "Please enter only whole numbers.";
            }

        } else {
            this.minBuyDollarTooltipMessage = "";
            this.tts.remove();
        }
    }

    onMinBuyDollarChange() {
        if (this.tradeMinimumsMinBuyDollarInputControl && this.tradeMinimumsMinBuyDollarInputControl.valid) {
            this.dollarPercentChanged.emit({
                key: 'buyMinimum',
                data: Number(this.tradeMinimumsMinBuyDollarInputControl.value)
            });
        }
    }

    onMinBuyDollarFocusOut() {
        if (this.tradeMinimumsMinBuyDollarInputControl && !this.tradeMinimumsMinBuyDollarInputControl.valid
            && this.tradeMinimumsMinBuyDollarInputControl.errors) {
            if (this.tradeMinimumsMinBuyDollarInputControl.hasError('requiredIfTouched')) {
                this.minBuyDollarTooltipMessage = "Min Buy $ is required";
            } else if (this.tradeMinimumsMinBuyDollarInputControl.hasError('NotANumber')) {
                this.minBuyDollarTooltipMessage = "Please enter only whole numbers.";
            } else if (this.tradeMinimumsMinBuyDollarInputControl.hasError('min') ||
                this.tradeMinimumsMinBuyDollarInputControl.hasError('max')) {
                this.minBuyDollarTooltipMessage = "Please enter only numbers between 0 and 999999999.";
            } else if (this.tradeMinimumsMinBuyDollarInputControl.hasError('pattern')) {
                this.minBuyDollarTooltipMessage = "Please enter only whole numbers.";
            }
        }
    }

    onMinBuyPercentInput() {
        if (this.tradeMinimumsMinBuyPercentInputControl && !this.tradeMinimumsMinBuyPercentInputControl.valid
            && this.tradeMinimumsMinBuyPercentInputControl.errors) {
            if (this.tradeMinimumsMinBuyPercentInputControl.hasError('requiredIfTouched')) {
                this.minBuyPercentTooltipMessage = "Min Buy % is required";
            } else if (this.tradeMinimumsMinBuyPercentInputControl.hasError('NotANumber')) {
                this.minBuyPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            } else if (this.tradeMinimumsMinBuyPercentInputControl.hasError('min') ||
                this.tradeMinimumsMinBuyPercentInputControl.hasError('max')) {
                this.minBuyPercentTooltipMessage = "Please enter only numbers between 0 and 100";
            } else if (this.tradeMinimumsMinBuyPercentInputControl.hasError('pattern')) {
                this.minBuyPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            }
        } else {
            this.minBuyPercentTooltipMessage = "";
            this.tts.remove();
        }
    }

    onMinBuyPercentChange() {
        if (this.tradeMinimumsMinBuyPercentInputControl && this.tradeMinimumsMinBuyPercentInputControl.valid) {
            this.dollarPercentChanged.emit({
                key: 'buyMinimumPercent',
                data: Number(this.tradeMinimumsMinBuyPercentInputControl.value)
            });
        }
    }

    onMinBuyPercentFocusOut() {
        if (this.tradeMinimumsMinBuyPercentInputControl && !this.tradeMinimumsMinBuyPercentInputControl.valid
            && this.tradeMinimumsMinBuyPercentInputControl.errors) {
            if (this.tradeMinimumsMinBuyPercentInputControl.hasError('requiredIfTouched')) {
                this.minBuyPercentTooltipMessage = "Min Buy % is required";
            } else if (this.tradeMinimumsMinBuyPercentInputControl.hasError('NotANumber')) {
                this.minBuyPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            } else if (this.tradeMinimumsMinBuyPercentInputControl.hasError('min') ||
                this.tradeMinimumsMinBuyPercentInputControl.hasError('max')) {
                this.minBuyPercentTooltipMessage = "Please enter only numbers between 0 and 100";
            } else if (this.tradeMinimumsMinBuyPercentInputControl.hasError('pattern')) {
                this.minBuyPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            }
        }
    }


    onMinSellDollarInput() {
        if (this.tradeMinimumsMinSellDollarInputControl && !this.tradeMinimumsMinSellDollarInputControl.valid
            && this.tradeMinimumsMinSellDollarInputControl.errors) {
            if (this.tradeMinimumsMinSellDollarInputControl.hasError('requiredIfTouched')) {
                this.minSellDollarTooltipMessage = "Min Sell $ is required";
            } else if (this.tradeMinimumsMinSellDollarInputControl.hasError('NotANumber')) {
                this.minSellDollarTooltipMessage = "Please enter only whole numbers.";
            } else if (this.tradeMinimumsMinSellDollarInputControl.hasError('min') ||
                this.tradeMinimumsMinSellDollarInputControl.hasError('max')) {
                this.minSellDollarTooltipMessage = "Please enter only numbers between 0 and 999999999.";
            } else if (this.tradeMinimumsMinSellDollarInputControl.hasError('pattern')) {
                this.minSellDollarTooltipMessage = "Please enter only whole numbers.";
            }
        } else {
            this.minSellDollarTooltipMessage = "";
            this.tts.remove();
        }
    }

    onMinSellDollarChange() {
        if (this.tradeMinimumsMinSellDollarInputControl && this.tradeMinimumsMinSellDollarInputControl.valid) {
            this.dollarPercentChanged.emit({
                key: 'sellMinimum',
                data: Number(this.tradeMinimumsMinSellDollarInputControl.value)
            });
        }
    }

    onMinSellDollarFocusOut() {
        if (this.tradeMinimumsMinSellDollarInputControl && !this.tradeMinimumsMinSellDollarInputControl.valid
            && this.tradeMinimumsMinSellDollarInputControl.errors) {
            if (this.tradeMinimumsMinSellDollarInputControl.hasError('requiredIfTouched')) {
                this.minSellDollarTooltipMessage = "Min Sell $ is required";
            } else if (this.tradeMinimumsMinSellDollarInputControl.hasError('NotANumber')) {
                this.minSellDollarTooltipMessage = "Please enter only whole numbers.";
            } else if (this.tradeMinimumsMinSellDollarInputControl.hasError('min') ||
                this.tradeMinimumsMinSellDollarInputControl.hasError('max')) {
                this.minSellDollarTooltipMessage = "Please enter only numbers between 0 and 999999999.";
            } else if (this.tradeMinimumsMinSellDollarInputControl.hasError('pattern')) {
                this.minSellDollarTooltipMessage = "Please enter only whole numbers.";
            }
        }
    }


    onMinSellPercentInput() {
        if (this.tradeMinimumsMinSellPercentInputControl && !this.tradeMinimumsMinSellPercentInputControl.valid
            && this.tradeMinimumsMinSellPercentInputControl.errors) {
            if (this.tradeMinimumsMinSellPercentInputControl.hasError('requiredIfTouched')) {
                this.minSellPercentTooltipMessage = "Min Sell % is required";
            } else if (this.tradeMinimumsMinSellPercentInputControl.hasError('NotANumber')) {
                this.minSellPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            } else if (this.tradeMinimumsMinSellPercentInputControl.hasError('min') ||
                this.tradeMinimumsMinSellPercentInputControl.hasError('max')) {
                this.minSellPercentTooltipMessage = "Please enter only numbers between 0 and 100";
            } else if (this.tradeMinimumsMinSellPercentInputControl.hasError('pattern')) {
                this.minSellPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            }
        } else {
            this.minSellPercentTooltipMessage = "";
            this.tts.remove();
        }
    }

    onMinSellPercentChange() {
        if (this.tradeMinimumsMinSellPercentInputControl && this.tradeMinimumsMinSellPercentInputControl.valid) {
            this.dollarPercentChanged.emit({
                key: 'sellMinimumPercent',
                data: Number(this.tradeMinimumsMinSellPercentInputControl.value)
            });
        }
    }

    onMinSellPercentFocusOut() {
        if (this.tradeMinimumsMinSellPercentInputControl && !this.tradeMinimumsMinSellPercentInputControl.valid
            && this.tradeMinimumsMinSellPercentInputControl.errors) {
            if (this.tradeMinimumsMinSellPercentInputControl.hasError('requiredIfTouched')) {
                this.minSellPercentTooltipMessage = "Min Sell % is required";
            } else if (this.tradeMinimumsMinSellPercentInputControl.hasError('NotANumber')) {
                this.minSellPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            } else if (this.tradeMinimumsMinSellPercentInputControl.hasError('min') ||
                this.tradeMinimumsMinSellPercentInputControl.hasError('max')) {
                this.minSellPercentTooltipMessage = "Please enter only numbers between 0 and 100";
            } else if (this.tradeMinimumsMinSellPercentInputControl.hasError('pattern')) {
                this.minSellPercentTooltipMessage = "Please enter only numbers, with up to two decimal places.";
            }
        }
    }

    onKeyDown(e: any) {
        if (e.keyCode && e.keyCode === 69) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    initializeFormStructure() {
        this.tradeMinimumsMinBuyDollarInputControl = new FormControl(this.minBuyDollar,
            [this.requiredIfTouchedValidatorFn.bind(this),
                Validators.min(this.minDollarValue),
                Validators.max(this.maxDollarValue),
                this.notANumberValidatorFn.bind(this),
                Validators.pattern(new RegExp("^[0-9]+(\.[0-9]{0,0})?$"))]);
        this.tradeMinimumsMinSellDollarInputControl = new FormControl(this.minSellDollar,
            [this.requiredIfTouchedValidatorFn.bind(this),
                Validators.min(this.minDollarValue),
                Validators.max(this.maxDollarValue),
                this.notANumberValidatorFn.bind(this),
                Validators.pattern(new RegExp("^[0-9]+(\.[0-9]{0,0})?$"))]);
        this.tradeMinimumsMinBuyPercentInputControl = new FormControl(this.minBuyPercent,
            [this.requiredIfTouchedValidatorFn.bind(this),
                Validators.min(this.minDollarPercent),
                Validators.max(this.maxDollarPercent),
                this.notANumberValidatorFn.bind(this),
                Validators.pattern(new RegExp("^[0-9]+(\.[0-9]{0,2})?$"))]);

        this.tradeMinimumsMinSellPercentInputControl = new FormControl(this.minSellPercent,
            [this.requiredIfTouchedValidatorFn.bind(this),
                Validators.min(this.minDollarPercent),
                Validators.max(this.maxDollarPercent),
                this.notANumberValidatorFn.bind(this),
                Validators.pattern(new RegExp("^[0-9]+(\.[0-9]{0,2})?$"))]);

        this.onMinBuyDollarFocusOut();
        this.onMinSellDollarFocusOut();
        this.onMinBuyPercentFocusOut();
        this.onMinSellPercentFocusOut();
    }

    notANumberValidatorFn(control: AbstractControl): { [key: string]: any } | null {
        const re = /"^\d+(?:\.\d+)?$"/;

        return (control.value != null && control.value.length > 0
            && (isNaN(control.value) ? {'NotANumber': {value: control.value}} : null));
    }

    requiredIfTouchedValidatorFn(control: AbstractControl): { [key: string]: any } | null {
        return ((control.dirty && (control.value === undefined
            || control.value === null
            || control.value === '')) ?
            {
                'requiredIfTouched': control.dirty && (control.value === undefined
                    || control.value === null
                    || control.value === '')
            }
            : null);
    }

    isValid() {
        let isValid = true;
        if (this.minBuyDollar) {
            isValid = isValid && this.isValidDollarValue(Number(this.minBuyDollar));
        }
        if(this.minSellDollar) {
            isValid = isValid && this.isValidDollarValue(Number(this.minSellDollar));
        }
        if(this.minBuyPercent) {
            isValid = isValid && this.isValidPercentValue(Number(this.minBuyPercent));
        }
        if(this.minSellPercent) {
            isValid = isValid && this.isValidPercentValue(Number(this.minSellPercent));
        }
        return isValid;
    }

    private isValidDollarValue(dollarValue: number): boolean {
        const regExp = new RegExp("^[0-9]+(\.[0-9]{0,0})?$");
        const validFormat = dollarValue.toString().match(regExp) != null;
        return this.minDollarValue <= dollarValue && dollarValue <= this.maxDollarValue && validFormat;
    }

    private isValidPercentValue(dollarValue: number): boolean {
        const regExp = new RegExp("^[0-9]+(\.[0-9]{0,2})?$");
        const validFormat = dollarValue.toString().match(regExp) != null;
        return this.minDollarPercent <= dollarValue && dollarValue <= this.maxDollarPercent && validFormat;
    }

    getItemsForAlternativeSecuritiesDropdown(searchString: string) {
        this.alternativeSecuritiesDropdown.set(DropdownFilterComponent.getFilteredList(searchString,this.alternativeSecurities));
    }

    openNewItemSecurityFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }
}
